export { default } from './Modal';
export type { ModalProps, ModalType } from './Modal';
